import React, {Component} from 'react';
import getFieldFactory from "../../Endpoint/FieldFactory";
import FieldGroups from "../FieldGroups";
import {connect} from "react-redux";
import {addSubField} from "../../../../../store/actions/subFields";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import ParametersNotice from "../../Parameters/ParametersNotice";

class DefaultFieldsFilter extends Component {

	state = {
		selectedFilterToAdd: ''
	};

	handleSelectedFilterToAdd = (e) => {
		this.setState({selectedFilterToAdd: e.target.value});
	};

	render() {

		const { addSubField, group } = this.props;

		const defaultFields = [
			getFieldFactory().getStatusFieldGroup( 'checkboxes' ),
			getFieldFactory().getPostTypes( 'checkboxes' ),
			getFieldFactory().getNewDefaultFieldGroup( 'title', 'Post title' ),
			getFieldFactory().getNewDefaultFieldGroup('post__in', 'Post ID'),
			getFieldFactory().getNewDefaultFieldGroup('page_id', 'Page ID'),
			getFieldFactory().getNewDefaultFieldGroup('pagename', 'Page name'),
			getFieldFactory().getNewDefaultFieldGroup('post_parent__in', 'Post parent ID'),
			getFieldFactory().getNewDefaultFieldGroup('post_parent__not_in', 'Post parent ID NOT'),
			getFieldFactory().getNewDefaultFieldGroup('post__not_in', 'Post ID NOT'),
			getFieldFactory().getNewDefaultFieldGroup('author__in', 'Author ID'),
			getFieldFactory().getNewDefaultFieldGroup('author_name', 'Author name'),
			getFieldFactory().getNewDefaultFieldGroup('author__not_in', 'Author name NOT'),
			getFieldFactory().getNewDefaultFieldGroup('s', 'Post search'),
      {
        name:   'post_date_exactly',
        label:  'Post date exactly',
        fields: [
          getFieldFactory().getSourceField(),
          getFieldFactory().getValueInputType( 'input', 'Value: (YYYY-mm-dd)'),
          {
            id:           'parameters',
            inputType:    'select',
            label:        'Parameter (YYYY-mm-dd)',
            source:       'parameters',
            sourceName:   'name',
            sourceValue:  'name',
            value:        '',
            defaultValue: 'Select a parameter',
          },
        ],
      },
      {
        name:   'post_date_before',
        label:  'Post date before',
        fields: [
          getFieldFactory().getSourceField(),
          getFieldFactory().getValueInputType( 'input', 'Value: (YYYY-mm-dd)'),
          {
            id:           'parameters',
            inputType:    'select',
            label:        'Parameter (YYYY-mm-dd)',
            source:       'parameters',
            sourceName:   'name',
            sourceValue:  'name',
            value:        '',
            defaultValue: 'Select a parameter',
          },
        ],
      },
      {
        name:   'post_date_after',
        label:  'Post date after',
        fields: [
          getFieldFactory().getSourceField(),
          getFieldFactory().getValueInputType( 'input', 'Value: (YYYY-mm-dd)'),
          {
            id:           'parameters',
            inputType:    'select',
            label:        'Parameter (YYYY-mm-dd)',
            source:       'parameters',
            sourceName:   'name',
            sourceValue:  'name',
            value:        '',
            defaultValue: 'Select a parameter',
          },
        ],
      },
		];

		return (
				<FieldGroupContext.Consumer>

					{({ endpointId, endpoint, currentItem, action }) => (

						<React.Fragment>
							<h3>Default Fields ({endpoint[action][currentItem].defaultFields.length})</h3>

							<p>Use this section for adding a filter for one or more default post fields. You can set a fixed value for it or use an already defined parameter.</p>

							<ParametersNotice parameters={endpoint.parameters}/>

							<label>Select a filter type:</label>
							<select value={this.state.selectedFilterToAdd} onChange={this.handleSelectedFilterToAdd}>
							<option value="">Select a field</option>
								{defaultFields.sort((a, b) => (a.label > b.label) ? 1 : -1).map((el, index) => <option key={index} value={el.name}>{el.label}</option>)}
							</select>

							<button
							onClick={() => addSubField(endpointId, defaultFields.filter(el => el.name === this.state.selectedFilterToAdd), currentItem, group, action)}
							disabled={!this.state.selectedFilterToAdd ? 'disabled' : ''}
							className="button-secondary"
							>
							Add a filter
							</button>

							<FieldGroups group={group} />

						</React.Fragment>
					)}

				</FieldGroupContext.Consumer>
		);
	}
}

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(DefaultFieldsFilter);
